/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from "react";
import SecondaryBtn from "../../common/form/SecondaryBtn";
import { Arr, Download, NoJobs, Rupee } from "../../common/svg/AllSvg";
import PaginationComponent from "../../common/form/PaginationComponent";
import { useSelector } from "react-redux";
import useSelectTable from "../../../shared/hooks/use-selectTable";
import Select, { components } from "react-select";
import { Link, useNavigate, useParams } from "react-router-dom";
import useAxios from "../../../shared/hooks/use-axios";
import { url } from "../../../shared/utils/url";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { sitemap } from "../../../shared/utils/sitemap";
import Error from "../../common/form/Error";

const DropdownIndicator = (props: any) => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <Arr className="fill-[#888] min-w-[9px]" />
            </components.DropdownIndicator>
        )
    );
};

const SubVacanciesList = ({ data, loading, setData, isError }: any) => {
    const lang: string = useSelector((state: any) => state.ui.lang);
    const theme: any = useSelector((state: any) => state.ui.theme);
    const { t } = useTranslation('common');
    const [page, setPage] = useState<number>(1);
    const [total, setTotal] = useState<number>(0);
    const [job, setJob] = useState<any[]>([])
    const [jobLoading, setJobLoading] = useState<boolean>(true)
    const [jobError, setJobError] = useState<boolean>(false)
    const loaderData: any[] = [1, 2, 3, 4, 5]
    const [size, setSize] = useState<any>({ label: `10 ${t("recruitment.home.per_page")}`, value: "10" });
    let totalPages: number = Math.ceil(total / +size?.value);
    const navigate = useNavigate();
    const params = useParams();
    let styles = useSelectTable(theme);
    const sizeList: any[] = [{ label: `10 ${t("recruitment.home.per_page")}`, value: "10" }, { label: `20 ${t("recruitment.home.per_page")}`, value: "20" }, { label: `30 ${t("recruitment.home.per_page")}`, value: "30" }]
    const sortByList: any[] = [{ label: `${t("recruitment.home.sort_by")} (Default)`, value: "Sort by (Default)" }]

    const getJobDetail = async () => {
        try {
            setJobLoading(true)
            setJobError(false)
            const res: any = await useAxios.get(`${(!!lang ? lang : "en") + url?.publicJob}?advertisement_id=${params?.id}&page=${page}&size=${size?.value}`);

            if (res && res.status === 200) {
                setJob(res?.data?.results)
                setJobLoading(false)
                setTotal(res?.data?.count)
            }
        } catch (error) {
            setJobError(true)
            setJobLoading(false)
            console.error("error while fetching job detail", error);
        }
    }

    const getDeptJobDetail = async () => {
        try {
            setJobLoading(true)
            setJobError(false)
            const res: any = await useAxios.get(`${(!!lang ? lang : "en") + url?.publicJob}?department_id=${params?.deptId}&page=${page}&size=${size?.value}`);

            if (res && res.status === 200) {
                setJob(res?.data?.results)
                setJobLoading(false)
                setTotal(res?.data?.count)
                res?.data?.results?.length > 0 && setData(res?.data?.results?.[0])
                sitemap()
            }
        } catch (error: any) {
            if (error?.response?.status === 404) {
                (!!params?.lang ? navigate(`/${params?.lang}/404`) : navigate("/404"))
            }
            setJobError(true)
            setJobLoading(false)
            console.error("error while fetching job detail", error);
        }
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        (!!params?.id && !!lang) && getJobDetail();
        (!!params?.deptId && !!lang) && getDeptJobDetail();
    }, [params?.id, params?.deptId, page, size, lang])

    useEffect(() => {
        if (!!lang) {
            let obj: any = sizeList?.find((item: any) => item?.value === size?.value)
            setSize(obj)
        }
    }, [lang])

    return (
        <div className="container flex flex-col h-full w-full gap-[20px] lg:py-[34px] py-[30px]">
            {/* detail */}
            {(!!params?.id && !isError) &&
                <div className="flex flex-col bg-primary border border-primary justify-between rounded-[10px] w-full gap-[15px] lg:rounded-[20px] md:flex-row md:px-[35px] md:py-[25.5px] px-[20px] py-[15px] xsm:items-center">
                    <div className="flex flex-col justify-between w-full gap-[15px] md:gap-[40px] md:justify-start md:w-auto xsm:flex-row xsm:items-center">
                        <div className="flex flex-col gap-[4px] md:gap-[8px]">
                            <h6 className="text-white font-medium"> {t("recruitment.home.ads_list.add_no")}</h6>
                            {loading ? <div className="bg-gray-200 h-[12px] rounded-full w-[200px] animate-pulse dark:bg-gray-700"></div> : <h4 className="text-[1.25rem] text-white font-bold leading-snug">{data?.adv_no}</h4>}
                        </div>

                        <div className="flex flex-col gap-[4px] md:gap-[8px]">
                            <h6 className="text-white font-medium"> {t("recruitment.home.ads_list.last_date")}</h6>
                            {loading ? <div className="bg-gray-200 h-[12px] rounded-full w-[80px] animate-pulse dark:bg-gray-700"></div> : <h4 className="text-[1.25rem] text-white font-bold leading-snug">{moment(data?.last_date_submission).format('MMM DD, YYYY')}</h4>}
                        </div>
                    </div>

                    {loading ?
                        <div className="bg-gray-200 h-[35px] rounded-[4px] w-[240px] animate-pulse dark:bg-gray-700 xlx:h-[40px]"></div>
                        : <Link to={data?.attach_pdf_details?.aws_file_url} download={true} target="_blank" className="flex bg-white border border-primary h-[35px] justify-center rounded-[4px] w-fit focus:shadow-[0_0_0_2px_#ffffff5e] gap-[8px] hover:shadow-[0_0_0_2px_#ffffff5e] items-center px-[15.5px] xlx:h-[40px]">
                            <div className="min-w-[14px]">
                                <Download className="fill-primary" />
                            </div>
                            <h5 className="text-primary font-bold uppercase"> {t("recruitment.home.deatil_ad")}</h5>
                        </Link>}
                </div>
            }

            {jobLoading ?
                <div className="h-full w-full overflow-x-auto">
                    <div className="inline-block min-w-full">
                        <div className="overflow-hidden">
                            <table className="table-auto w-full">
                                <thead className="w-full">
                                    <tr className="bg-[#D9D9D9] bg-opacity-[0.3] border border-[#D9D9D9] border-opacity-[0.3] w-full dark:border-[#454545]">
                                        <th className="h-full text-[#121212] text-sm !text-center dark:text-white font-bold leading-snug px-[16px] py-[3px] xlx:py-[6px]">
                                            {/* {t("recruitment.home.ads_list.s_no")} */}
                                        </th>
                                        <th className="h-full text-[#121212] text-sm !text-left dark:text-white font-bold leading-snug px-[16px] py-[3px] xlx:py-[6px]">
                                            {t("recruitment.home.job_list.dept")}
                                        </th>
                                        <th className="h-full text-[#121212] text-sm !text-left dark:text-white font-bold leading-snug px-[16px] py-[3px] xlx:py-[6px]">
                                            {t("recruitment.home.job_list.emp")}
                                        </th>
                                        <th className="h-full text-[#121212] text-sm !text-left dark:text-white font-bold leading-snug px-[16px] py-[3px] xlx:py-[6px]">
                                            {t("recruitment.home.job_list.category")}
                                        </th>
                                        <th className="h-full text-[#121212] text-sm !text-center dark:text-white font-bold leading-snug px-[16px] py-[3px] xlx:py-[6px]">
                                            {t("recruitment.home.job_list.grade")}
                                        </th>
                                        <th className="h-full text-[#121212] text-sm !text-left dark:text-white font-bold leading-snug px-[16px] py-[3px] xlx:py-[6px]">
                                            {t("recruitment.home.job_list.pay_scale")}
                                        </th>
                                        <th className="h-full px-[16px] py-[3px] xlx:py-[6px]"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(loaderData) && loaderData.map((item: any, index: number) => (
                                        <tr className="bg-white border border-gray-200 w-full animate-pulse dark:bg-bgDarkDull dark:border-gray-700" key={index}>
                                            <td className="px-[16px] py-[10px]">
                                                <div className="flex justify-center items-center">
                                                    <div className="flex bg-gray-200 h-[60px] justify-center rounded-[8px] w-[60px] dark:bg-gray-700 items-center xlx:h-[80px] xlx:w-[80px]"></div>
                                                </div>
                                            </td>

                                            <td className="px-[16px] py-[10px]">
                                                <div className="flex flex-col gap-[4px]">
                                                    <div className="bg-gray-200 h-[12px] rounded-full w-[80px] dark:bg-gray-700"></div>
                                                    <div className="bg-gray-200 h-[12px] rounded-full w-[150px] dark:bg-gray-700"></div>
                                                </div>
                                            </td>

                                            <td className="px-[16px] py-[10px]">
                                                <div className="flex gap-[8px] items-center">
                                                    <div className="bg-gray-200 h-[27px] rounded-full w-[80px] dark:bg-gray-700 xlx:h-[30px]"></div>
                                                    <div className="bg-gray-200 h-[27px] rounded-full w-[80px] dark:bg-gray-700 xlx:h-[30px]"></div>
                                                </div>
                                            </td>

                                            <td className="px-[16px] py-[10px]">
                                                <div className="bg-gray-200 h-[12px] rounded-full w-[60px] dark:bg-gray-700"></div>
                                            </td>

                                            <td className="px-[16px] py-[10px]">
                                                <div className="flex justify-center items-center">
                                                    <div className="bg-gray-200 h-[12px] rounded-full w-[20px] dark:bg-gray-700"></div>
                                                </div>
                                            </td>

                                            <td className="px-[16px] py-[10px]">
                                                <div className="bg-gray-200 h-[12px] rounded-full w-[60px] dark:bg-gray-700"></div>
                                            </td>

                                            <td className="px-[16px] py-[10px]">
                                                <div className="flex justify-end items-center">
                                                    <div className="bg-gray-200 h-[35px] rounded-[4px] w-[65px] dark:bg-gray-700 xlx:h-[40px] xlx:w-[100px]"></div>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                :
                <>
                    {jobError ? <Error /> : <>
                        {job?.length > 0 ? <>
                            {/* sort & size */}
                            <div className={`flex items-center justify-between gap-[10px] w-full flex-wrap ${!!params?.id && "mt-[8px] md:mt-[15px] xl:mt-[25px]"}`}>
                                <h5 className="text-[#121212] dark:text-white font-bold uppercase">{lang === "en" ? `Showing ${((+page - 1) * +size?.value) + 1} – ${(((+page - 1) * +size?.value) + 1) + 9} of ${job?.length} results` : lang === "hi" ? `${job?.length} में से ${((+page - 1) * +size?.value) + 1} – ${(((+page - 1) * +size?.value) + 1) + 9} परिणाम दिखा रहा है` : `${job?.length} पैकी ${((+page - 1) * +size?.value) + 1} – ${(((+page - 1) * +size?.value) + 1) + 9} निकाल दाखवत आहे`}</h5>

                                <div className="flex gap-[7px] items-center">
                                    <Select options={sortByList} styles={styles} className="!w-fit" value={{ label: `${t("recruitment.home.sort_by")} (Default)`, value: "Sort by (Default)" }} isSearchable={false} components={{ DropdownIndicator }} classNamePrefix="react-select" />

                                    <Select options={sizeList} styles={styles} className="!w-fit" isSearchable={false} components={{ DropdownIndicator }} classNamePrefix="react-select" value={size} onChange={(e: any) => setSize(e)} />
                                </div>
                            </div>

                            {/* data */}
                            <div className="h-full w-full overflow-x-auto">
                                <div className="inline-block min-w-full">
                                    <div className="overflow-hidden">
                                        <table className="table-auto w-full">
                                            <thead className="w-full">
                                                <tr className="bg-[#D9D9D9] bg-opacity-[0.3] border border-[#D9D9D9] border-opacity-[0.3] w-full dark:border-[#454545]">
                                                    <th className="h-full text-[#121212] text-sm !text-center dark:text-white font-bold leading-snug px-[16px] py-[3px] xlx:py-[6px]">
                                                        {/* {t("recruitment.home.ads_list.s_no")} */}
                                                    </th>
                                                    <th className="h-full text-[#121212] text-sm !text-left dark:text-white font-bold leading-snug px-[16px] py-[3px] xlx:py-[6px]">
                                                        {t("recruitment.home.job_list.dept")}
                                                    </th>
                                                    <th className="h-full text-[#121212] text-sm !text-left dark:text-white font-bold leading-snug px-[16px] py-[3px] xlx:py-[6px]">
                                                        {t("recruitment.home.job_list.emp")}
                                                    </th>
                                                    <th className="h-full text-[#121212] text-sm !text-left dark:text-white font-bold leading-snug px-[16px] py-[3px] xlx:py-[6px]">
                                                        {t("recruitment.home.job_list.category")}
                                                    </th>
                                                    <th className="h-full text-[#121212] text-sm !text-center dark:text-white font-bold leading-snug px-[16px] py-[3px] xlx:py-[6px]">
                                                        {t("recruitment.home.job_list.grade")}
                                                    </th>
                                                    <th className="h-full text-[#121212] text-sm !text-left dark:text-white font-bold leading-snug px-[16px] py-[3px] xlx:py-[6px]">
                                                        {t("recruitment.home.job_list.pay_scale")}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {Array.isArray(job) && job.map((item: any, index: number) => (
                                                    <tr className={`${((index % 2) === 0) ? "bg-[#FCFCFC] dark:bg-[#343539]" : "bg-[#F6F9FC] dark:bg-[#3f4143]"} border border-[#E5E5E5] dark:border-[#454545]`} key={index}>
                                                        <td className="px-[16px] py-[10px]">
                                                            <div className="flex justify-center items-center">
                                                                <div style={{ backgroundColor: `${item?.department_details?.bg_color}` }} className="flex h-[60px] justify-center rounded-[8px] w-[60px] items-center xlx:h-[80px] xlx:w-[80px]">
                                                                    <img src={item?.department_details?.icon?.aws_file_url} alt="icon" className="w-[50%] xlx:w-auto" />
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td className="px-[16px] py-[10px]">
                                                            <div className="flex flex-col w-[150px] gap-[4px] xlx:w-[200px]">
                                                                <h6 className="text-blackDull dark:text-textBlackDull font-medium">{item?.department_details?.name}</h6>
                                                                <h4 className="text-[1.25rem] text-primaryText dark:text-white font-semibold leading-snug">{item?.job_role}</h4>
                                                            </div>
                                                        </td>
                                                        <td className="px-[16px] py-[10px]">
                                                            <div className="flex flex-wrap w-[150px] gap-[8px] items-center xlx:w-[210px]">
                                                                {Array?.isArray(item?.employment_nature_detail) && item?.employment_nature_detail?.map((i: any, index: number) => (
                                                                    <div key={index} className="flex bg-[#F1F1F1] justify-center rounded-[30px] text-base text-blackDull w-fit dark:bg-[#d4d5d838] dark:text-textBlackDull font-semibold items-center px-[15px] py-[3px]">
                                                                        {i?.title}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </td>
                                                        <td className="px-[16px] py-[10px]">
                                                            <div className="flex gap-[3px] items-start whitespace-nowrap">
                                                                {(Array.isArray(item?.post_category_detail) && item?.post_category_detail?.map((i: any, idx: number) =>
                                                                    <h5 className="text-blackDark dark:text-textBlackDark font-semibold" key={idx}>
                                                                        {(i?.category) + " - " + (i?.post_available) + `${item?.post_category_detail?.length !== idx + 1 ? ' | ' : ' '}`}
                                                                    </h5>
                                                                ))}
                                                            </div>
                                                        </td>
                                                        <td className="text-base text-blackDark text-center dark:text-textBlackDark font-medium px-[16px] py-[10px]">
                                                            {!!item?.grade_pay_details?.grade_code ? item?.grade_pay_details?.grade_code : "-"}
                                                        </td>

                                                        <td className="px-[16px] py-[10px]">
                                                            <div className="flex justify-between w-full gap-[30px] items-center">
                                                                <div className="flex gap-[8px] items-center whitespace-nowrap">
                                                                    <div className="min-w-[21px]">
                                                                        <Rupee />
                                                                    </div>
                                                                    <h5 className="text-blackDark dark:text-textBlackDark font-medium"> {!!item?.grade_pay_details?.pay_scale ? item?.grade_pay_details?.pay_scale : `${item?.annual_ctc}`}</h5>
                                                                </div>

                                                                {!item?.offline && <div className="flex justify-center items-center">
                                                                    <SecondaryBtn title={t("recruitment.home.apply_btn")} css="px-[15px] xlx:px-[30px] uppercase font-bold" onClick={() => !!params?.lang ? navigate(`/${params?.lang}/vacancies/${item?.advertisement_details?.id}/${item?.id}`) : navigate(`/vacancies/${item?.advertisement_details?.id}/${item?.id}`)} />
                                                                </div>}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            {/* pagination */}
                            <div className="flex justify-center w-full items-center">
                                <PaginationComponent
                                    page={page}
                                    total={totalPages}
                                    setPage={setPage}
                                />
                            </div>
                        </> : <div className="flex flex-col justify-center items-center py-[100px] xlx:py-[145px]">
                            <NoJobs />

                            <div className="flex flex-col justify-center gap-[4px] items-center mt-[25px]">
                                <h3 className="text-primaryText dark:text-white font-bold">{t("recruitment.home.no_ads.job_title")}</h3>
                                <h5 className="text-blackDull text-center dark:text-textBlackDull font-medium">{t("recruitment.home.no_ads.desc")}</h5>
                            </div>
                        </div>}
                    </>}
                </>}

        </div>
    );
};

export default SubVacanciesList;